import { AutomationJsonSchema, DatasetType } from '@/types/automationFields.ts';

export const outputTypeSupportsSchemaRef = (outputType: DatasetType) =>
  outputType === DatasetType.Json ||
  outputType === DatasetType.Dataframe ||
  outputType === DatasetType.File;

export const schemaSupportsOutputType = (schema: AutomationJsonSchema, outputType: DatasetType) =>
  outputType !== DatasetType.File || schema.json_schema?.type === 'string';
